export enum SvgIcons {
  TOOLTIP = "tooltip-icon",
  CALENDAR = "calendar-icon",
  CONFIRMATION = "confirmation-icon",
  CLOSE = "close-icon",
  PRINTER = "printer-icon",
  PDF = "pdf-icon",
  SHOW_PASSWORD = "show-pass-icon",
  HIDE_PASSWORD = "hide-pass-icon",
  CHEVRON_ICON = "chevron-icon",
  SUCCESS = "success-icon",
  ERROR = "error-icon",
  INFO = "info-icon",
}
